import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cookies from "js-cookie";

i18n.use(initReactI18next).init({
  lng: Cookies.get("locale") || "id",
  fallbackLng: "id",
  resources: {
    en: {
      translation: {
        greetings: { welcome: "Hello", to: "to" },
        signin: {
          emailPlaceholder: "Enter Email",
          waPlaceholder: "Enter WhatsApp Number",
          submit: "Continue",
          continue: "Continue with",
          otpPlaceholder: "Verification Code",
          otpInstruction: "Enter the verification code we sent to",
          resend: "Resend",
          successOtp: "Verification code successfully sent to",
          failedOtp: "Failed to send verification code to",
          privacyText1: "We value your trust. Please read our",
          privacyPolicy: "Privacy Policy",
          and: "and",
          privacyText2: "Terms of Service",
          privacyText3: "to learn how we protect your data.",
        },
        register: {
          greetings: "Welcome to Becoming a Mitra Kartini",
          greetingInfo:
            "Since this is your first time joining, we will first conduct a few confirmations with you as the account administrator!",
          next: "Next",
          back: "Back",
          accountTitle: "Account Information",
          storeTitle: "Registered Stores",
          userTitle: "Registered Users",
          bankTitle: "Bank Information",
          pinTitle: "PIN Settings",
          agreementTitle: "Agreement Confirmation",
          accountSubtitle: "Complete the account information below.",
          storeSubtitle:
            "The store name listed below has been registered by us. You can add your own store after completing the registration.",
          userSubtitle:
            "The user names listed below have been registered by us. You can add your own users after completing the registration.",
          bankSubtitle:
            "The bank information provided will serve as the destination for E-Wallet funds withdrawn by the account users.",
          pinSubtitle:
            "The PIN will be required when you want to withdraw your E-Wallet balance. Make sure not to forget your PIN.",
          agreementSubtitle:
            "Usage Agreement Please read carefully. Scroll down and check the agree box.",
          agreementStatement:
            "I hereby agree to the agreement as well as the terms & conditions.",
        },

        navBar: {
          home: "Home",
          redeem: "Redeem",
          display: "Display",
          transaction: "Transaction",
          ewallet: "E-Wallet",
          inbox: "Inbox",
        },
        home: {
          title: "Accounts Detail",
          titlePromo: "Ongoing Promotion",
          subtitlePromo:
            "Come check out the awesome promos happening right now!",
          transactionHistory: "Transaction History",
          emptyImage: "Promo image not available",
          accountName: "Account Name",
          outletName: "Outlet Name",
          outletAddress: "Outlet Address",
          accountOwner: "Account Owner",
          outletAdmin: "Outlet Admin",
          outletUser: "Outlet User",
          startDate: "Mitra Start Date",
          status: "Status Mitra",
          emptyVoucher: "No Active Vouchers",
          remainingDeposit: "Deposit Remaining",
          validUntil: "Valid Until",
        },
        redeem: {
          title: "Unique Voucher Code",
          confirmation: "Confirm Unique Voucher Code",
          mechanismError:
            "It looks like you don’t have permission to use the Manual Redemption feature at this time. Please contact support or refer to your account settings to check access levels.",
          activeProjectList: "Here are the active projects in your store",
          selectMechanism: "Select Mechanism",
          selectSku: "Select SKU",
          confirmVoucherRedemption: "Confirm Voucher Redemption",
          clickForMechanismDetail: "Click here to view mechanism details",
          discountAmount: "Discount Amount",
          uvcType: "UVC Type",
          voucherName: "Voucher Name",
          voucherPeriod: "Voucher Period",
          voucherAmount: "Voucher Amount",
          companyName: "Company Name",
          projectName: "Project Name",
          brandName: "Brand Name",
          skuName: "SKU Name",
          receiptPhoto: "Receipt Photo",
          retakePhoto: "Retake Photo",
          redeemVoucher: "Redeem Voucher",
          viewReceiptExample: "to view an example of receipt photo capture",
          receiptFoldHint:
            "If the receipt is too long, it may be folded so that the top section and the product details receiving the promotion are visible in the photo.",
          receiptVisibilityHint:
            "Ensure the transaction details (receipt header) and the list of promotional products are visible (if the receipt is too long, it can be folded so the promo products and receipt header can be captured).",
          redeemSuccess: "Voucher redemption successful",
          invalidReceiptPhoto:
            "The receipt photo is unclear or does not meet the requirements.",
          static: "Static",
          dynamic: "Dynamic",
          promoMechanism: "Promo Mechanism",
          voucherDetail: "Voucher Detail",
          uploadingReceipt: "Uploading Receipt",
        },
        transaction: {
          tabTransaction: "Transaction",
          tabSubsidy: "Subsidy & Withdrawal",
          filterAll: "All Transaction Type",
          filterRedemption: "Redemption",
          filterTransit: "Transit",
          filterDeposit: "Deposit",
          filterSubsidy: "Subsidy",
          filterWithdrawal: "Withdrawal",
          filterapproved: "Redemption Approved",
          title: "Transaction History",
          selectLabel: "All Outlet",
          phoneNumber: "WhatsApp Number",
          nominal: "Nominal",
          voucher: "Voucher Code",
          status: "Status",
          timeStamp: "Time Stamp",
          type: "Transaction Type",
          outletName: "Outlet Name",
          detail: "Description",
          download: "DOWNLOAD REPORT",
        },
        ewallet: {
          select: "Select Project",
          download: "DOWNLOAD REPORT",
          deposit:
            "Deposit is the total budget allocated for activities in your store. The deposit amount may change without prior notice.",
          transit:
            "Transit is the total amount currently in the approval process and will be transferred to the E-wallet balance.",
          ewallet:
            "E-Wallet is the total amount that you can withdraw to a registered bank account. Withdrawal fees may apply at the time of withdrawal.",
          ewalletExt: "The minimum withdrawal amount is Rp. 12,000.",
          ewalletBalance: "E-Wallet Balance",
          depositBalance: "Deposit Balance",
          transitBalance: "Transit Balance",
          date: "Date",
          type: "Transaction Type",
          description: "Description",
        },
        profile: {
          header: "User Management",
          account: "Account",
          bankAcc: "Bank Account",
          bankWarning: "Please update your account bank data.",
          memberWarn:
            " Member account information cannot be changed by member account. If you see information that seems unfit/inappropriate, please contact your admin to modify your desired changes.",
          emptyUser: "You don't have any user yet.",
          emptyOutlet: "You don't have any outlet yet.",
          firstName: "First Name",
          lastName: "Last Name",
          adminEmail: "Admin Email",
          failedDeleteMsg: "Failed to delete member",
          updateMsg: "User data successfully updated",
          deleteTitle: "Delete Outlet",
          logout: "LOGOUT",
          save: "Save",
        },
        noAccess: {
          title: "Access Denied!",
          description:
            "Sorry, but you don't have permission to access. Can't access this page. Unable to provide information from it.",
          back: "Go Back",
        },
        common: {
          confirm: "Confirm",
          back: "Back",
          clickHere: "Click here",
          success: "Success",
          tryAgain: "Try Again",
          skip: "Skip",
        },
      },
    },
    id: {
      translation: {
        greetings: { welcome: "Halo", to: "di" },
        signin: {
          emailPlaceholder: "Masukkan Email",
          waPlaceholder: "Masukkan Nomor WhatsApp",
          submit: "Lanjutkan",
          continue: "Lanjutkan dengan",
          otpPlaceholder: "Kode Verifikasi",
          otpInstruction:
            "Masukkan kode verifikasi yang telah kami kirimkan ke",
          resend: "Kirim Ulang",
          successOtp: "Kode verifikasi berhasil dikirim ke",
          failedOtp: "Gagal mengirim kode verifikasi ke",
          privacyText1: "Kami menghargai kepercayaan Anda. Bacalah",
          privacyPolicy: "Kebijakan Privasi",
          and: "dan",
          privacyText2: "Ketentuan Layanan",
          privacyText3: "kami untuk mengetahui cara kami melindungi data Anda.",
        },
        register: {
          greetings: "Selamat Bergabung menjadi Mitra Kartini",
          greetingInfo:
            "Karena ini adalah kali pertama Anda bergabung maka kami akan melakukan beberapa konfirmasi terlebih dahulu kepada Anda selaku administrator akun ya!",
          next: "Lanjut",
          back: "Kembali",
          accountTitle: "Informasi Akun",
          storeTitle: "Toko Terdaftar",
          userTitle: "Pengguna Terdaftar",
          bankTitle: "Informasi Bank",
          pinTitle: "Pengaturan PIN",
          agreementTitle: "Konfirmasi Persetujuan",
          accountSubtitle: "Lengkapi informasi akun dibawah.",
          storeSubtitle:
            "Nama toko dibawah adalah yang telah kami daftarkan. Anda dapat menambah toko sendiri saat selesai registrasi.",
          userSubtitle:
            "Nama pengguna dibawah adalah yang telah kami daftarkan. Anda dapat menambah pengguna sendiri saat selesai registrasi.",
          bankSubtitle:
            "Informasi bank yang dicantumkan akan menjadi tujuan transfer dana E-Wallet akun yang ditarik oleh pengguna.",
          pinSubtitle:
            "PIN akan diminta saat Anda ingin menarik saldo E-Wallet. Pastikan Anda tidak melupakan PIN Anda.",
          agreementSubtitle:
            "Persetujuan Penggunaan Harap dibaca dengan seksama. Silahkan scroll kebawah dan mencentang tanda setuju.",
          agreementStatement:
            "Dengan ini saya setuju terhadap perjanjian serta syarat & ketentuan",
        },
        navBar: {
          home: "Beranda",
          redeem: "Penukaran",
          display: "Pajangan",
          transaction: "Transaksi",
          ewallet: "E-Wallet",
          inbox: "Pesan",
        },
        home: {
          title: "Detail Akun",
          titlePromo: "Promo Berjalan",
          subtitlePromo: "Yuk lihat promo apa saja yang sedang jalan.",
          transactionHistory: "Riwayat Transaksi",
          emptyImage: "Gambar tidak tersedia",
          accountName: "Nama Akun",
          outletName: "Nama Toko",
          outletAddress: "Alamat Toko",
          accountOwner: "Pemilik Akun",
          outletAdmin: "Admin Toko",
          outletUser: "Pengguna Toko",
          startDate: "Tanggal Mulai Mitra",
          status: "Status Kemitraan",
          emptyVoucher: "Tidak Ada Voucher",
          remainingDeposit: "Sisa Deposit",
          validUntil: "Berjalan Hingga",
        },
        redeem: {
          title: "Kode Voucher",
          confirmation: "Konfirmasi Kode Voucher",
          mechanismError:
            "Sepertinya Anda tidak memiliki izin untuk menggunakan fitur Manual Redemption saat ini. Silakan hubungi dukungan atau periksa pengaturan akun Anda untuk memeriksa tingkat akses.",
          activeProjectList: "Berikut project yang aktif di toko anda",
          selectMechanism: "Pilih Mekanisme",
          selectSku: "Pilih SKU",
          confirmVoucherRedemption: "Konfirmasi Tukar Voucher",
          clickForMechanismDetail: "Klik disini untuk detail mekanisme",
          discountAmount: "Besaran Potongan Harga",
          uvcType: "Tipe UVC",
          voucherName: "Nama Voucher",
          voucherPeriod: "Periode Voucher",
          voucherAmount: "Nominal Voucher",
          companyName: "Nama Perusahaan",
          projectName: "Nama Project",
          brandName: "Nama Brand",
          skuName: "Nama SKU",
          receiptPhoto: "Foto Struk",
          retakePhoto: "Foto Ulang",
          redeemVoucher: "Tukar Voucher",
          viewReceiptExample: "untuk melihat contoh foto pengambilan struk",
          receiptFoldHint:
            "Apabila struk terlalu panjang, struk dapat dilipat agar bagian atas struk serta rincian produk yang mendapatkan promo dapat terlihat di dalam foto.",
          receiptVisibilityHint:
            "Pastikan detail transaksi (kepala struk) dan list pembelian produk berpromo bisa terlihat (apabila struk terlalu panjang, struk bisa dilipat sehingga produk promo terkait dan kepala struk dapat difoto).",
          redeemSuccess: "Proses tukar voucher berhasil",
          invalidReceiptPhoto:
            "Foto struk tidak jelas atau tidak memenuhi syarat.",
          static: "Statis",
          dynamic: "Dinamis",
          promoMechanism: "Mekanisme Promo",
          voucherDetail: "Detail Voucher",
          uploadingReceipt: "Mengunggah Struk",
        },
        transaction: {
          tabTransaction: "Transaksi",
          tabSubsidy: "Subsidi & Penarikan",
          filterAll: "Semua Jenis Transaksi",
          filterRedemption: "Redemption",
          filterTransit: "Transit",
          filterDeposit: "Deposit",
          filterWithdrawal: "Withdrawal",
          filterSubsidy: "Subsidi",
          filterApproved: "Redemption Valid",
          title: "Riwayat Transaksi",
          selectLabel: "Semua Outlet",
          phoneNumber: "Nomor WhatsApp",
          nominal: "Nominal",
          voucher: "Kode Voucher",
          status: "Status",
          timeStamp: "Waktu Transaksi",
          outletName: "Nama Toko",
          download: "UNDUH LAPORAN",
          type: "Tipe Transaksi",
          detail: "Keterangan",
        },
        ewallet: {
          select: "Pilih Project",
          download: "UNDUH LAPORAN",
          deposit:
            "Deposit adalah total anggaran yang telah dialokasikan untuk kegiatan di toko Anda. Deposit dapat berubah tanpa pemberitahuan sebelumnya.",
          transit:
            "Transit adalah jumlah total yang sedang dalam proses approval lalu akan di teruskan ke E-wallet balance.",
          ewallet:
            "E-Wallet adalah jumlah total yang dapat Anda tarik ke rekening bank yang telah didaftarkan. Ada biaya penarikan yang dapat berlaku pada saat penarikan.",
          ewalletExt: "Minimum penarikan (withdrawal) sebesar Rp. 12,000.",
          ewalletBalance: "Saldo E-Wallet",
          depositBalance: "Saldo Deposit",
          transitBalance: "Saldo Transit",
          date: "Tanggal",
          type: "Tipe Transaksi",
          detail: "Keterangan",
          description: "Deskripsi",
        },
        profile: {
          header: "Manajemen Pengguna",
          account: "Akun",
          bankAcc: "Rekening Bank",
          bankWarning: "Harap perbarui data rekening bank Anda.",
          memberWarn:
            "Informasi akun anggota tidak dapat diubah oleh akun anggota. Jika Anda melihat informasi yang tidak sesuai, silakan hubungi admin Anda untuk melakukan perubahan yang diinginkan.",
          emptyUser: "Anda belum memiliki user.",
          emptyOutlet: "Anda belum memiliki outlet.",
          firstName: "Nama Depan",
          lastName: "Nama Belakang",
          adminEmail: "Email Admin",
          failedDeleteMsg: "Gagal menghapus anggota",
          updateMsg: "Data pengguna berhasil diperbarui",
          deleteTitle: "Hapus Outlet",
          logout: "KELUAR",
          save: "Simpan",
        },
        noAccess: {
          title: "Akses Ditolak!",
          description:
            "Maaf, Anda tidak memiliki izin untuk mengakses halaman ini. Anda tidak dapat membuka halaman ini dan informasi dari halaman ini tidak dapat ditampilkan.",
          back: "Kembali",
        },
        common: {
          confirm: "Konfirmasi",
          back: "Kembali",
          success: "Berhasil",
          clickHere: "Klik disini",
          tryAgain: "Coba Lagi",
          skip: "Lewati",
        },
      },
    },
  },
});

export default i18n;
